module.exports = __webpack_public_path__ + "static/media/obudowa.65d0856d.png";